<template src="./vehicleservicehistory.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
import DocumentPopup from "@/pages/vehicles/vehicledocumentspopup/vehicledocumentspopup.vue";
var moment = require("moment");
import GetcurrencySymbol from "@/assets/js/currency_sign.js";
export default {
  components: {
    DocumentPopup,
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  props: ["NewVehicle", "type"],
  data() {
    return {
      currency_type : GetcurrencySymbol(),
      ImageEndpoint: Endpoints.Helper.Image + "/",
      Services: [],
      service_export_data: [],
      TotalCost: 0,
      MileageUnit: "Mileage",
    };
  },
  mounted() {
    setTimeout(() => {
      this.GetVehicleServices();
    }, 4000);
    var CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (CompanyData.mileage_unit == 2) {
      this.MileageUnit = "KM";
    }
  },
  methods: {
    GetVehicleServices() {
      var obj = { token: localStorage.getItem("token") };
      if (this.type === "Asset") {
        obj.asset_id = this.NewVehicle.id;
      } else {
        obj.vehicle_id = this.NewVehicle.id;
      }
      obj.type = this.type;
      Axios.post(Endpoints.Vehicle.Services, obj).then((Response) => {
        if (Response.data.success) {
          this.Services = Response.data.services;
          this.TotalCost = Response.data.total_cost;

          this.service_export_data = [];
          if (this.Services.length > 0) {
            this.Services.forEach((element) => {
              var obj = {};
              if (this.type == "Vehicle") {
                obj["Vehicle"] = element.vehicle;
                obj[this.MileageUnit] = element.mileage;
              } else if (this.type == "Trailer") {
                obj["Trailer"] = element.vehicle;
              } else if (this.type == "Asset") {
                obj["Asset"] = element.asset;
                obj["Miles"] = element.miles;
                obj["Hours"] = element.hours;
              }
              obj["Cost"] = element.cost;
              obj["Date"] = element.date;
              obj["Work Completed"] = element.work;
              this.service_export_data.push(obj);
            });
          }
        }
      });
    },
    AddServiceDocument() {
      this.$parent.AddDocument("service");
    },
    EditServiceDocument(document) {
      this.$parent.EditDocument(document);
    },
    DeleteServiceDocument(document_id) {
      this.$parent.DeleteDocument(document_id);
    },
  },
};
</script>
<style scoped>
.download-excel-btn {
  float: right;
  margin-right: 10px;
}
</style>
